import * as LJS from "../../lib/littlejs.esm";
import { tilesize, tilesheets } from '../const/tiles.ts';
import Globals from '../globals';
/**
 * The Object class represents all game objects that the player can
 * encounter in the game. It takes care of creating a lightTile
 * and darkTile, and switching between them depending on the world,
 * or even completely hide the object if it is exclusive to one
 * world (instanciated with the world parameter).
 * It also manages solid and walkable objects for the pathfinding
 * of enemies, and finally make all the objects go up at a steady
 * pace to simulate the never ending descent of the player.
 */
class Object extends LJS.EngineObject {
    constructor(pos, tileIndex, world, invTileIndex) {
        // If the position if oustide of the well, we do not spawn the object
        let darkTile = LJS.tile(tileIndex, tilesize, tilesheets.DARK);
        super(pos, LJS.vec2(1, 1), darkTile);
        this.walkable = false;
        this.solid = true;
        this.world = null;
        this.disabled = false;
        this.tileIndex = 0;
        this.defaultMass = 0;
        this.darkTile = darkTile;
        this.lightTile = LJS.tile(tileIndex, tilesize, tilesheets.LIGHT);
        this.world = world;
        // If we have a tile to display when we are in the other world (transparent platform for example)
        if (invTileIndex) {
            this.darkTileInv = LJS.tile(invTileIndex, tilesize, tilesheets.DARK);
            this.lightTileInv = LJS.tile(invTileIndex, tilesize, tilesheets.LIGHT);
        }
        this.defaultCollision();
        this.mass = this.defaultMass;
    }
    update() {
        // If the object has the 'world' property set, it only exists in the corresponding world
        // If we are not in its world, we disable collision, hide the sprite and we do not update
        if (this.world && this.world != Globals.world) {
            this.setCollision(false, false, false, false);
            // If we don't have a tile to show in the other world, we hide it
            if (!this.lightTileInv) {
                this.color = LJS.hsl(1, 1, 1, 0);
            }
            this.disabled = true;
            this.mass = 0;
        }
        else {
            this.color = LJS.hsl(1, 1, 1, 1);
            this.defaultCollision();
            this.disabled = false;
            this.mass = this.defaultMass;
        }
        // If the object is outside of the view we destroy it to free memory
        if (this.pos.y > Globals.depth + Globals.chunkSize) {
            this.destroy();
        }
        this.tileInfo = Globals.world == Globals.LIGHT ? this.lightTile : this.darkTile;
        // If we have a tile to show in the other world
        if (this.world && this.world != Globals.world && this.lightTileInv) {
            // @ts-ignore
            this.tileInfo = Globals.world == Globals.LIGHT ? this.lightTileInv : this.darkTileInv;
        }
        super.update();
    }
    defaultCollision() {
        this.setCollision(true, false, false, false);
    }
}
export default Object;
